import React from 'react';
import { Flash, FlashType } from './types';

export type Alert = (type: FlashType, content: string, header: string) => void;

export interface FlashContextInterface {
    flash: {
    flashes: Flash[];
    alert: Alert;
    remove: (id: string) => void;
    removeAll: (ids: string[]) => void;
    }
}

export const FlashContext = React.createContext<FlashContextInterface>({flash:{alert: () => undefined, remove: () => undefined, removeAll: () => undefined, flashes:[]}});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function withFlashContext(Component: any) {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return function FlashContextComponent(props: any): JSX.Element {
        return (
            <FlashContext.Consumer>
                {ctx => <Component {...props} flash={ctx.flash} />}
            </FlashContext.Consumer>);
    };
}
